import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ROLE_OPTIONS } from '../../core/utils/roles.util';

@Component({
  selector: 'app-seleccion-roles',
  imports: [CommonModule, RouterLink],
  templateUrl: './seleccion-roles.html',
  styleUrl: './seleccion-roles.css',
})
export class SeleccionRoles {
  // Catálogo único de roles y rutas de destino para simular ingreso por perfil.
  readonly roles = ROLE_OPTIONS;
}
